var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"Hearder"},[_c('Header')],1),_c('div',{staticClass:"Content",class:{ 'active': _vm.isActive, 'active2': _vm.isActive2 }},[_c('router-view')],1),_c('div',{staticClass:"ProgressBar",style:({ width: _vm.progress + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }